import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/vineyardStyles/form'
import { api, actionCreators } from 'store/modules/vineyardStyles'

const metadata = {
  icon: 'vine',
  page: 'vineyardStyles',
  dialogSize: dialogSizes.MD
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
